// What real ground has on it, by floor, from all 935 populated surface squares
// (`scripts/scaperune/research/survey.ts`, `biomeKits`). Keys are `o` or `u` and a floor's id, as
// stored: overlay 14, underlay 48. per100 is decorations per 100 tiles of that floor in the world.
// Each id's a loc that follows the ground and doesn't block, looked at on a sheet: no animated,
// tall or heavy ones (over 60 triangles: this is thousands of locs), and none that are a slab of indoor floor. A floor
// that isn't here goes by its biome's own decoration.
export const FLOOR_KITS: Record<string, { per100: number; ids: number[] }> = {
    o2: { per100: 28, ids: [336, 14483, 14482, 14484, 14486, 337] },
    o3: { per100: 34, ids: [11439, 336, 11438, 11440, 559, 13412, 15630] },
    o10: { per100: 25, ids: [336, 335, 1248, 337, 4736, 1247] },
    o11: { per100: 37, ids: [14495, 14501, 12931, 14498, 14492, 12930, 14497, 336] },
    o171: { per100: 35, ids: [336, 335, 1248, 337, 4736, 1247] },
    o12: { per100: 25, ids: [336, 335, 1248, 337, 4736, 1247] },
    o14: { per100: 49, ids: [325, 185, 4343, 326, 339, 3949, 4342] },
    o22: { per100: 42, ids: [320, 321, 319, 4736] },
    o25: { per100: 20, ids: [729, 728, 730, 342, 341, 4736] },
    o26: { per100: 20, ids: [330, 729, 10030, 10845, 18934, 331, 329] },
    o80: { per100: 34, ids: [51827, 13409, 51826, 51805, 3949, 339, 3614] },
    o81: { per100: 49, ids: [3949, 3614, 4343, 3948, 51809] },
    o82: { per100: 31, ids: [3703, 5325, 3709, 5328, 5324, 5329] },
    o83: { per100: 36, ids: [3709, 3703, 3706, 3702, 3708, 3704, 3710] },
    o99: { per100: 73, ids: [14483, 14482, 14486, 14487] },
    o102: { per100: 34, ids: [5328, 5204, 2173, 5327, 5205, 2172, 5329, 2174] },
    o106: { per100: 28, ids: [3614, 320, 3949, 319, 5335, 3950, 3613] },
    o110: { per100: 45, ids: [20778, 20777, 20743, 20779, 5336] },
    o115: { per100: 20, ids: [34413, 34414, 20743, 14486, 34415] },
    o227: { per100: 18, ids: [46950, 3170, 3171, 3169, 16824] },
    u16: { per100: 13, ids: [26396, 336, 47520, 46644] },
    u26: { per100: 49, ids: [339, 51815, 51827, 51811, 51814, 51810, 51826] },
    u48: { per100: 43, ids: [1257, 1247, 4736, 1258, 4735, 3549] },
    u49: { per100: 52, ids: [4736, 4735, 5335, 1258, 1257, 1247] },
    u50: { per100: 43, ids: [1257, 1258, 1242, 4736, 51805, 3549, 4735] },
    u51: { per100: 26, ids: [4735, 4736, 1257, 1247] },
    u52: { per100: 43, ids: [51805, 51811, 51804, 1243, 51815, 51827, 51810, 51814] },
    u54: { per100: 36, ids: [3549, 20742, 2382, 50947] },
    u55: { per100: 26, ids: [336, 11439, 14483, 4735] },
    u56: { per100: 44, ids: [336, 14483, 337, 11439] },
    u58: { per100: 16, ids: [559, 13412, 13413] },
    u59: { per100: 9, ids: [26396, 13412, 13413, 559] },
    u61: { per100: 13, ids: [729, 728, 330, 730, 16823, 46762, 331] },
    u62: { per100: 11, ids: [729, 730, 728, 3170, 341, 342, 1242, 1243] },
    u63: { per100: 35, ids: [325, 185, 1247, 326, 31778, 4736, 5335, 3549] },
    u64: { per100: 39, ids: [330, 4736, 14522, 320, 325, 4735, 3549, 6818] },
    u67: { per100: 50, ids: [4735, 9486, 4343, 3549, 7210] },
    u68: { per100: 34, ids: [729, 728, 51815, 1243, 730, 51814, 10845, 342] },
    u92: { per100: 49, ids: [3709, 3703, 11439, 3708, 3710, 4340, 3706, 3702] },
    u94: { per100: 38, ids: [3703, 3709, 11439, 16824, 3704, 16823, 14483, 3702] },
    u96: { per100: 47, ids: [5336, 5335, 31778, 4343, 31777] },
    u97: { per100: 39, ids: [4340, 3709, 16823, 4341, 16824, 4339, 5325] },
    u129: { per100: 45, ids: [729, 14501, 728] },
    u143: { per100: 65, ids: [3936, 5336, 5335] },
    u144: { per100: 48, ids: [5335, 5336] },
    u145: { per100: 46, ids: [14483, 14522, 14482, 14486, 14484, 325, 14485, 336] },
    u146: { per100: 57, ids: [14486, 14483, 14572, 14485, 14492, 14487] },
    u147: { per100: 52, ids: [14492, 14495, 14491, 14493, 14486, 14601, 14496] },
    u148: { per100: 51, ids: [14495, 14494, 14496, 14492, 14486] },
    u218: { per100: 18, ids: [46644, 47520, 336, 53589, 335] },
    u223: { per100: 31, ids: [51814, 60200, 729, 60199, 51827, 51815, 60201] },
};
